import React, { useEffect } from 'react';
import {   InfoBox,   ExerciseBox,   CodeBlock, CodeEditor,  InlineCode,   SectionTitle,  Note,  TableContainer,  Highlight,  PatternContainer,  SectionHeading,  SubHeading,  TwoColGrid,  ThreeColGrid,  GridItem,  Divider,  MutedText, Separator, BoldTextParagraph, CorrectionBox} from '../../../../components/course/CourseComponents';

const Chapitre2Content = ({ courseId = 'baseprogrammation' }) => {
  
  // Effet pour donner le focus à l'éditeur quand le composant se monte
  useEffect(() => {
    // Le focus sera géré par la prop autoFocus du CodeEditor
  }, []);

  return (
    <>
     <InfoBox title="Objectif" color="blue">
        <p className="mb-0">
        Afficher un message dans la console.<br/>
        Ajouter des commentaires dans le code.
        </p>
      </InfoBox>       


      <Separator type="text" text="Afficher un message dans la console" color="gray-darker" size="md" />
      <SectionTitle>Afficher un message dans la console</SectionTitle>
      <p>
      Ta première instruction sera d'afficher la phrase : <InlineCode>"Bonjour !"</InlineCode> dans la console.<br/>
      La console est un endroit où l'ordinateur affiche des messages. C'est un outil très puissant pour les développeurs.<br/>
      Pour dire à l'ordinateur d'afficher un message, on utilise la fonction <InlineCode>print()</InlineCode> 

      <br/>
        <Note type="gray" title="🔧 Afficher un message dans la console : ">
        <CodeBlock language="javascript">
          print("message");
        </CodeBlock>
      </Note>

      <MutedText>💡 La vraie fonction en JavaScript est console.log("message"), mais pour faire plus simple, je l'ai raccourcie. C'est la seule fonction modifiée sur tout le site.
      </MutedText>
      </p>

      <p>
      Pour cela, je mets à ta disposition deux outils : un éditeur (à gauche) qui te permet d'écrire ton code, et une console à droite, qui affiche le résultat.
      </p>

      <Note type="exercice" title="🧪 À toi de jouer : ">
        Affiche le mot "Bonjour" dans la console :<br/>
        - Utilise la fonction <InlineCode>print()</InlineCode><br/>
        - Mets "Bonjour" entre guillemets<br/>
        - N'oublie pas les parenthèses !<br/>
        Puis clique sur le bouton Play ▶️ pour l'exécuter.
        
        <CorrectionBox>
          <CodeBlock language="javascript">
            print("Bonjour");
          </CodeBlock>
        </CorrectionBox>
      </Note>
 
      <CodeEditor
        courseId={courseId}
        editorId="print"
        title="Éditeur de code interactif"
        showConsole={true}
        height="200px"
        initialCode=""
        autoFocus={true}
      />

      <p>
        Si tout s'est bien passé, tu devrais voir le mot <InlineCode>Bonjour</InlineCode> s'afficher dans la console ✅<br/>
        Sinon, l'ordinateur t'indiquera une erreur. Cela peut être :
      </p>

      <ul className="list-disc list-inside mb-4">
        <li>un oubli de parenthèse )</li>
        <li>un guillemet mal fermé "</li>
        <li>ou le mot print mal écrit</li>
      </ul>

      <Note type="info" title="🎯 À essayer :">
        Change le texte entre les guillemets pour voir le résultat s'adapter !
        <CodeBlock language="javascript">
          print("Je m'appelle ...");
        </CodeBlock>
      </Note>

      <Note type="info" title="💡 Remarque :">
        Dans beaucoup de langages, chaque ligne d'instruction se termine par un ; (point-virgule).<br/>
        En JavaScript, ce n'est pas obligatoire, mais c'est conseillé.
      </Note>

      <Separator type="text" text="Commentaire" color="gray-darker" size="md" />
      <SectionTitle>Commentaires dans le code</SectionTitle>
     


        Si tu veux écrire une note pour toi dans le code (non lue par l'ordinateur), utilise // au début de la ligne.
        <CodeBlock language="javascript">
{`// Ceci est un commentaire
print("Bonjour !");`}
        </CodeBlock>

        <Note type="info" title="🎯 À essayer :">
        Ajoute un commentaire dans le code ci-dessus et exécute le programme pour voir le résultat.
      </Note>
    

      <BoldTextParagraph>
        Prochaine étape : les variables. C'est fondamental pour faire un vrai programme !
      </BoldTextParagraph>

  </>
  );
};

export default Chapitre2Content; 